<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Provedor"
  [style]="{ width: '600px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-6">
            <label class="label-required">RUC</label>
            <input pInputText formControlName="ruc" type="text" />
            <div
              *ngIf="
                fg.get('ruc').invalid &&
                (fg.get('ruc').dirty || fg.get('ruc').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('ruc').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('ruc').errors?.minlength">
                <small class="p-error">Debe tener una longitud de 11.</small>
              </div>
              <div *ngIf="fg.get('ruc').errors?.maxlength">
                <small class="p-error">Debe tener una longitud de 11.</small>
              </div>
              <div *ngIf="fg.get('ruc').errors?.pattern">
                <small class="p-error"
                  >El RUC no puede contener letras.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label class="label-required">Nombre</label>
            <input pInputText formControlName="name" type="text" />
            <div
              *ngIf="
                fg.get('name').invalid &&
                (fg.get('name').dirty || fg.get('name').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('name').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('name').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('name').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 255.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label>Dirección</label>
            <input pInputText formControlName="address" type="text" />
            <div
              *ngIf="
                fg.get('address').invalid &&
                (fg.get('address').dirty || fg.get('address').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('address').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('address').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('address').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Email</label>
            <input
              pInputText
              formControlName="email"
              type="text"
              placeholder="Ejemplo: something@domain.com"
            />
            <div
              *ngIf="
                fg.get('email').invalid &&
                (fg.get('email').dirty || fg.get('email').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('email').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('email').errors?.email">
                <small class="p-error"
                  >Por favor ingrese un email válido.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>N° de teléfono</label>
            <input
              pInputText
              formControlName="mobile"
              type="text"
              numbersOnly
            />
            <div
              *ngIf="
                fg.get('mobile').invalid &&
                (fg.get('mobile').dirty || fg.get('mobile').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('mobile').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('mobile').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud de 9.</small
                >
              </div>
              <div *ngIf="fg.get('mobile').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud de 9.</small
                >
              </div>
              <div *ngIf="fg.get('mobile').errors?.pattern">
                <small class="p-error"
                  >El teléfono no puede contener letras.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
